// src/components/store/sections/product-cards/Variant100OrigamiCrestFuchsiaGlowCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingCart, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant100OrigamiCrestFuchsiaGlowCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    discountPercent,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full bg-white rounded-3xl border-2 border-fuchsia-200 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col justify-between group select-none">
      <div className="p-4 pb-2 flex flex-col items-center text-center">
        <div
          className="px-4 py-1 bg-gradient-to-r from-fuchsia-500 to-pink-600 text-white font-black text-[10px] uppercase tracking-widest shadow-xs mb-2"
          style={{ clipPath: "polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%)" }}
        >
          SAVE {discountPercent}% • ৳{currentPrice.toLocaleString()}
        </div>
        <Link href={productUrl} className="relative w-36 h-36 my-1 block">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-md" />
        </Link>
        <span className="text-[9px] font-black uppercase tracking-widest text-fuchsia-700 block truncate max-w-full">{categoryName}</span>
        <Link href={productUrl} className="block w-full mt-0.5">
          <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
        </Link>
        <div className="flex items-center justify-center gap-0.5 text-amber-400 mt-1">
          {[1, 2, 3, 4, 5].map((s) => (
            <Star key={s} className="w-3 h-3 fill-amber-400" />
          ))}
          <span className="text-[10px] text-slate-400 font-bold ml-1">({rating.toFixed(1)})</span>
        </div>
      </div>

      <div
        className="p-3.5 pt-5 bg-gradient-to-r from-fuchsia-500 to-pink-600 flex items-center justify-between gap-2"
        style={{ clipPath: "polygon(0 24%, 100% 0, 100% 100%, 0 100%)" }}
      >
        <span className="text-sm font-black font-mono text-white">৳{currentPrice.toLocaleString()}</span>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="px-4 py-1.5 rounded-xl bg-white text-slate-900 font-black text-[10px] uppercase tracking-wider shadow-xs active:scale-95 transition-all cursor-pointer flex items-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <ShoppingCart className="w-3.5 h-3.5" />}
          <span>{added ? "Added" : "Add Cart"}</span>
        </button>
      </div>
    </div>
  );
}
